export type TRecordsVMEmbSent = {
  records: TEmbSentEnhancedTagInfo[];
  totalUpdatedQuantity: number;
};
export type TRecordsVMEmbReceived = {
  records: TEmbReceiveEnhancedTagInfo[];
  totalUpdatedQuantity: number;
};
export type TEmbEnhancedTagInfo = TEmbReceiveEnhancedTagInfo | TEmbSentEnhancedTagInfo;
export type TEmbReceiveEnhancedTagInfoWithoutResolvedQuantityInfo = {
  embType: 'EMB_RECEIVED';
  tagDTO: {
    tagId: string;
    tagDetails: ITagBctx[];
    vendor: string;
    vendorDs: string;
    sentQty: number;
    quickTagInfo: Record<ITagBctx['k'], string>;
    dispatchedQty: TEmbReceiveDispatchedQty;
  };
  updatedDispatchedQtyDTO: TEmbReceiveUpdateDispatchedQty;
};
export type TEmbReceiveEnhancedTagInfo = TEmbReceiveEnhancedTagInfoWithoutResolvedQuantityInfo & {
  resolvedQuantityInfo: {
    updatedDispatchQty: number;
    updatedMissingQty: number;
    currentDispatchQty: number;
    currentMissingQty: number;
    newDefectivesCount: number;
  };
};
export type TEmbReceiveEditQtyModalData = {
  enhancedTagInfo: TEmbReceiveEnhancedTagInfo;
  isUpdateFromReasonListPage: boolean;
};
export type TEmbSentEnhancedTagInfo = {
  embType: 'EMB_SENT';
  tagDTO: {
    tagId: string;
    tagDetails: ITagBctx[];
    quickTagInfo: Record<ITagBctx['k'], string>;
    //this is the tag-quantity
    sentQty: number;
  };
  updatedQty: number;
};

export const EMB_ACTION_TO_DISPLAY_NAME_MAP: Record<TEmbSentAction | TEmbReceiveAction, string> = {
  DISPATCH_QTY_UPDATED: 'emb_log_listing_details.DISPATCH_QTY_UPDATED',
  EMB_RECEIVED: 'emb_log_listing_details.EMB_RECEIVED',
  EMB_SENT: 'emb_log_listing_details.EMB_SENT',
  REMOVE_TAG: 'emb_log_listing_details.REMOVE_TAG',
  REMOVE_TRANSACTION: 'emb_log_listing_details.REMOVE_TRANSACTION',
};

// DTOs

type TBusinessContextType =
  | 'buyer'
  | 'po'
  | 'product_type'
  | 'style'
  | 'color'
  | 'size'
  | 'search_id'
  | 'bundleQuantity';

interface IBctxViz {
  k: TBusinessContextType;
  d: string;
  h: boolean;
  ctx: number;
  g: boolean;
}

export interface ITagBctx {
  k: IBctxViz['k'];
  v: string;
}

type TFilter = {
  key: string;
  value: string;
  selected: boolean;
  id: string;
};

export type TFilterData = {
  [key: string]: TFilter[];
};

export type TFilterConf = {
  key: string;
  name: string;
};

export type TFilterEmb = {
  filterType: string;
  values: string[];
  displayName?: string; // TODO: NISHA remove this after all changes
};
export type TEmbDateError = 'START_IS_GREATER' | 'RANGE_OUT_OF_WEEK_LENGTH' | 'START_OUT_OF_MONTH_RANGE';
export type TEmbFilterType = 'DATE' | 'VENDOR' | 'TAG_FIELD' | 'TOGGLE_FILTER';
export type TEmbFilter = TEmbVendorFilter | TEmbDateRangeFilter | TEmbTagFieldFilter;
type TEmbToggleType = 'DEVICE_ONLY' | 'SHIFT_ONLY';
export type TEmbVendorFilter = {
  filterType: 'VENDOR';
  values: string[];
};
export type TEmbDateRangeFilter = {
  filterType: 'DATE';
  values: number[];
};
export type TEmbTagFieldFilter = {
  filterType: 'TAG_FIELD';
  values: string[];
  key: string;
};
type TEmbToggleFilter = {
  filterType: 'TOGGLE_FILTER';
  values: boolean;
  filter: TEmbToggleType;
};

export type TEmbVendorList = {
  id: string;
  name: string;
  checked: boolean;
  category_id?: string;
  group_id?: string[];
};

export type TMultiSelectItem = {
  id: string;
  name: string;
  selected: boolean;
};

export type TEmbAppTypesDetails = {
  currentAppType: string;
  embSentAppType: string;
  embReceivedAppType: string;
};

//verified
export type TEmbAppDetails = TEmbAppTypesDetails & {
  factoryId: string;
  appVersion: string;
  shift: string;
  subject: string;
  deviceId: string;
  dnm: string;
  dnr: string;
  shiftDn: string;
  snm: string;
  dnrk: string;
  an: string;
  urId: string;
  urNm: string;
};

export type TEmbSentCreateItem = {
  tagId: string;
  sentQty: number;
};
export interface IEditQuantityConfig {
  minQuantity: number | null;
  maxQuantity: number | null;
}
export type TEmbAPIStatus = 'SUCCESS' | 'FAILURE';
export type TEmbListType = 'TRANSACTION_LOG' | 'AUDIT_LOG';
export type TEmbRemoveAction = 'REMOVE_TAG' | 'REMOVE_TRANSACTION';
export type TEmbSentAction = 'EMB_SENT' | TEmbRemoveAction;
export type TEmbTagDetail = {
  k: string;
  v: string;
};

export type TEmbLogListingDetailItemVm = TEmbReceiveLogListingDetailItemVM | TEmbSentLogListingDetailItemVM;

export type TEmbReceiveLogListingDetailItemVM = {
  item: TEmbReceiveLogListingDetailItem;
  isFiltered: boolean;
  embType: 'EMB_RECEIVED';
  vendorDs: string;
  quickTagInfo: Record<ITagBctx['k'], string>;
};

export type TEmbSentLogListingDetailItemVM = {
  isFiltered: boolean;
  embType: 'EMB_SENT';
  item: TEmbSentLogListingDetailItem;
  vendorDs: string;
  quickTagInfo: Record<ITagBctx['k'], string>;
};
export type TEmbLogListingDetailItemVM = TEmbSentLogListingDetailItemVM | TEmbReceiveLogListingDetailItemVM;

export type TEmbSentLogListingDetailItem = {
  tagId: string;
  tagDetails: ITagBctx[];
  sentQty: number;
};

export type TEmbReceiveDispatchedQty = {
  ftt: number;
  defectives: number;
  rectified: number;
};
export type TEmbReceiveLogListingDetailItem = {
  tagId: string;
  tagDetails: ITagBctx[];
  sentQty: number;
  estId: string;
  dispatchedQty: TEmbReceiveDispatchedQty;
  vendor: string;
};

export type TEmbTagStatus = 'FOUND' | 'NOT_FOUND';

export type TEmbSentTagDetails = {
  tagId: string;
  vendor: string;
  tagDetails: ITagBctx[];
  sentQty: number;
};

export type TEmbDefectiveDTO = {
  id: string;
  name: string;
};

export type TEmbDefectiveDTOWithQty = TEmbDefectiveDTO & {
  qty: number;
  panelNumbers?: string[];
};
export type TEmbReceiveUpdatedDispatchedQtyWithoutRectified = {
  ftt: number;
  defectives: TEmbDefectiveDTOWithQty[];
};
export type TEmbReceiveCreateItem = {
  tagId: string;
  vendor: string;
  vendorName: string;
  dispatchedQtyInDTO: TEmbReceiveUpdatedDispatchedQtyWithoutRectified;
};

export type TEmbReceiveAction = 'EMB_RECEIVED' | TEmbRemoveAction | 'DISPATCH_QTY_UPDATED';

export type TEmbType = 'EMB_SENT' | 'EMB_RECEIVED';

export type TEmbReceiveUpdateDispatchedQty = TEmbReceiveUpdatedDispatchedQtyWithoutRectified & {
  rectified: number;
};

// EMB SENT APIs
export type TREQUEST_EMB_LANDING_COUNT = {
  appDetails: TEmbAppDetails;
  filters: TEmbFilter[];
};
export type TRESPONSE_EMB_LANDING_COUNT = {
  pieceCount: number;
  embType: TEmbType;
};

export type TREQUEST_EMB_SENT_CREATE = {
  appDetails: TEmbAppDetails;
  items: TEmbSentCreateItem[];
  vendor: string;
  eventTime: number;
  vendorName: string;
};

export type TREQUEST_EMB_RECEIVE_CREATE = {
  appDetails: TEmbAppDetails;
  items: TEmbReceiveCreateItem[];
  eventTime: number;
};

export type TREQUEST_EMB_RECEIVE_UPDATE = {
  appDetails: TEmbAppDetails;
  dispatchedQty: TEmbReceiveUpdateDispatchedQty;
  tagId: string;
  eventTime: number;
};

export type TEmbSupportedFilters = {
  vendors: string[];
  tagFieldFilters: Record<string, string[]>;
};

export type TREQUEST_EMB_LOG_LISTING = {
  appDetails: TEmbAppDetails;
  filters: TEmbFilter[];
  pageNo: number;
  pageSize: number;
};

export type TRESPONSE_EMB_LOG_LISTING = TEmbSentLogListing | TEmbReceiveLogListing;
export type TEmbSentLogListingItem = {
  estId: string;
  eventTime: number;
  vendor: string;
  sentQty: number;
  lastAction: TEmbSentAction;
  tagsCount: number;
};

export type TEmbSentLogListing = {
  items: TEmbSentLogListingItem[];
  totalRecords: number;
  listType: TEmbListType;
  embType: 'EMB_SENT';
  selectedFilters: TEmbFilter[];
  supportedFilters: TEmbSupportedFilters;
  totalConsolidatedSentQty: number;
};

export type TEmbSentLogListingItemVM = {
  item: TEmbSentLogListingItem;
  embType: 'EMB_SENT';
  lastActionDs: string;
  vendorDs: string;
};

export type TEmbReceiveLogListingItemVM = {
  item: TEmbReceiveLogListingItem;
  embType: 'EMB_RECEIVED';
  lastActionDs: string;
  vendorDs: string;
};

export type TEmbReceiveLogListingItem = {
  ertId: string;
  eventTime: number;
  vendors: string[];
  sentQty: number;
  lastAction: TEmbReceiveAction;
  dispatchedQty: number;
  tagsCount: number;
};

export type TEmbReceiveLogListing = {
  items: TEmbReceiveLogListingItem[];
  totalRecords: number;
  listType: TEmbListType;
  embType: 'EMB_RECEIVED';
  selectedFilters: TEmbFilter[];
  supportedFilters: TEmbSupportedFilters;
  totalConsolidatedDispatchQty: number;
};
export type TREQUEST_EMB_LOG_LISTING_DETAILS =
  | TREQUEST_EMB_SENT_LOG_LISTING_DETAILS
  | TREQUEST_EMB_RECEIVE_LOG_LISTING_DETAILS;
export type TRESPONSE_EMB_LOG_LISTING_DETAILS = TEmbSentLogListingDetails | TEmbReceiveLogListingDetails;

export type TREQUEST_EMB_SENT_LOG_LISTING_DETAILS = {
  appDetails: TEmbAppDetails;
  estId: string;
};

export type TREQUEST_EMB_RECEIVE_LOG_LISTING_DETAILS = {
  appDetails: TEmbAppDetails;
  ertId: string;
};

export type TEmbLogListingDetails = TEmbSentLogListingDetails | TEmbReceiveLogListingDetails;

export type TEmbSentLogListingDetails = {
  estId: string;
  items: TEmbSentLogListingDetailItem[];
  vendor: string;
  consolidatedSentQty: number;
  eventTime: number;
  embType: 'EMB_SENT';
  listType: TEmbListType;
};

export type TEmbReceiveLogListingDetails = {
  ertId: string;
  items: TEmbReceiveLogListingDetailItem[];
  vendors: string[];
  consolidatedSentQty: number;
  consolidatedReceivedQty: number;
  eventTime: number;
  embType: 'EMB_RECEIVED';
  listType: TEmbListType;
};

export type TREQUEST_EMB_SENT_TAG_DETAILS = {
  appDetails: TEmbAppDetails;
  tagId: string;
};

export type TRESPONSE_EMB_SENT_TAG_DETAILS = {
  status: TEmbTagStatus;
  embSentItem: TEmbSentTagDetails;
};

export type TREQUEST_EMB_REMOVE_TRANSACTION =
  | TREQUEST_EMB_RECEIVE_REMOVE_TRANSACTION
  | TREQUEST_EMB_SENT_REMOVE_TRANSACTION;

export type TREQUEST_EMB_RECEIVE_REMOVE_TRANSACTION = {
  appDetails: TEmbAppDetails;
  ertId: string;
  eventTime: number;
};

export type TREQUEST_EMB_SENT_REMOVE_TRANSACTION = {
  appDetails: TEmbAppDetails;
  estId: string;
  eventTime: number;
};

export type TREQUEST_EMB_REMOVE_TAG = {
  appDetails: TEmbAppDetails;
  tagId: string;
  eventTime: number;
};
export type TEmbError = TEmbTagLevelError | TEmbTopLevelError;
export type TEmbErrorType = 'TOP_LEVEL' | 'TAG_LEVEL';
export type TEmbTopLevelError = {
  errorType: 'TOP_LEVEL';
  errors: string[];
};
export type TEmbTagLevelError = {
  errorType: 'TAG_LEVEL';
  tagId: string;
  errors: string[];
};
export type TRESPONSE_EMB_CRUD_OPERATIONS = {
  status: TEmbAPIStatus;
  errors: TEmbError[];
};

export type TRESPONSE_EMB_RECEIVE_GET_DEFECTIVES = {
  status: TEmbAPIStatus;
  defectives: TEmbDefectiveDTOWithQty[];
  errors: TEmbError[];
  requestId: string;
};

export type TREQUEST_EMB_RECEIVE_UPDATE_DEFECTIVES = {
  appDetails: TEmbAppDetails;
  tagId: string;
  rectifiedDefectives: TEmbDefectiveDTOWithQty[];
  eventTime: number;
};

export type TRESPONSE_EMB_RECEIVE_UPDATE_DEFECTIVES = {
  status: TEmbAPIStatus;
  errors: TEmbError[];
  requestId: string;
};

export type TEmbReceiveEditQtyUpdateDetailsMetadata = {
  isUpdateFromReasonListPage: boolean;
  defectivesWithPanelNumbers: TDefectivewithQtyAndPanelNumbersWithSelectedFlag[];
};

export type TDefectivewithQtyAndPanelNumbersWithSelectedFlag = TEmbDefectiveDTO & {
  qty: number;
  panelNumbers: {
    panelNo: string;
    selected: boolean;
  }[];
};
